module.exports = __webpack_public_path__ + "static/img/65.ec240be0.gif";